import { memo } from 'react';
import { useTimerCounter } from './hooks';

function Counter() {
  useTimerCounter();
  return null;
}

export default memo(Counter);
